import { render } from "./Transport.vue?vue&type=template&id=d234865a"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\a1bg493225\\Desktop\\logika\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__